import Vue from 'vue';
import { API_HOST } from '../constants';

/* eslint-disable camelcase */

export default {
  get(params = {}) {
    return Vue.axios.get(`${API_HOST}/shopping-website`, { params });
  },
  getCategories(zone_code) {
    return Vue.axios.get(`${API_HOST}/website-categories`, { params: { zone_code } });
  },
  getWebisteZone() {
    return Vue.axios.get(`${API_HOST}/website-zone`);
  },
};



// WEBPACK FOOTER //
// ./src/api/website.js